import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  VStack,
  Icon,
  Flex,
  Text,
  Input,
  Button,
  Td,
  IconButton,
  Select,
  Stack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  useColorModeValue,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  SimpleGrid,
} from "@chakra-ui/react";

import axios from "axios";
import { Link } from "react-router-dom";
import { FaPlus, FaSync, FaEdit, FaPrint } from "react-icons/fa";
import Print_pdf_Exam_result from "./Print_pdf_Exam_result";
import {
  FaChalkboardTeacher,
  FaCalendarAlt,
  FaBook,
  FaUserTie,
  FaFileAlt,
  FaPen,
  FaAward,
  FaClipboardList,
  FaTasks,
  FaRegFileAlt,
} from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Exam_Result = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [students, setStudents] = useState([]);
  const [exams, setExams] = useState([]);
  const [exam, setExam] = useState([]);

  const [grades, setGrades] = useState([]);
  const [compliments, setCompliments] = useState([]);
  const [examDetails, setExamDetails] = useState([]);
  const [error, setError] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");

  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [enteredMarks, setEnteredMarks] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedCompliment, setSelectedCompliment] = useState("");
  const [description, setDescription] = useState("");
  const [examDate, setExamDate] = useState("");
  const [writtenMark, setWrittenMark] = useState("");
  const [internalMark, setInternalMark] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  //   const [examDetails, setExamDetails] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const isClassAndDivisionSelected = selectedClass && selectedDivision;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [selectedExamId, setSelectedExamId] = useState("");
  const [externalMark, setExternalMark] = useState("");
  const [totalMark, setTotalMark] = useState("");

  const bgColor = useColorModeValue("white", "gray.700");
  const selectedTabBg = useColorModeValue("teal.100", "teal.600");
  const selectedTabColor = "teal.800";

  const [academicId, setAcademicId] = useState(
    sessionStorage.getItem("Academic")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setAcademicId(sessionStorage.getItem("Academic"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Fetch classes
  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => setClasses(response.data.data || []))
      .catch((error) => console.error("Error fetching classes:", error));
  }, []);

  // Fetch divisions when a class is selected
  useEffect(() => {
    if (selectedClass) {
      axios
        .get(`${BASE_URL}/admin/class/division.php`)
        .then((response) => setDivisions(response.data.data || []))
        .catch((error) => console.error("Error fetching divisions:", error));
    } else {
      setDivisions([]);
    }
  }, [selectedClass]);

  useEffect(() => {
    if (selectedClass && selectedDivision) {
      axios
        .post(`${BASE_URL}/admin/exam/depending_student.php`, {
          class_id: selectedClass,
          division_id: selectedDivision,
        })
        .then((response) => setStudents(response.data.data || []))
        .catch((error) => console.error("Error fetching students:", error));
    }
  }, [selectedClass, selectedDivision]);
  useEffect(() => {
    if (selectedClass && academicId) {
      console.log("Selected Class:", selectedClass);

      axios
        .post(`${BASE_URL}/staff/exam/depending_exam.php`, {
          class_id: selectedClass,
        })
        .then((response) => {
          console.log("Exam Data:", response.data.data);

          // Apply filtering based on academicId
          const filteredExams = (response.data.data || []).filter(
            (exam) => exam.academic_year_id === academicId
          );

          setExams(filteredExams);
        })
        .catch((error) => console.error("Error fetching exams:", error));
    }
  }, [selectedClass, academicId]); // Re-run when selectedClass or academicId changes
  // Fetch exam details based on selected class and division
  useEffect(() => {
    if (selectedClass && selectedDivision) {
      axios
        .post(
          `${BASE_URL}/admin/exam/list_all_exam_details.php`,
          {
            class_id: selectedClass,
            division_id: selectedDivision,
            school_id: sessionStorage.getItem("school_id"),
          }
        )
        .then((response) => {
          const details = response.data.data || [];
          console.log("class students", response);

          // Get Academic ID from sessionStorage
          // const academicId = sessionStorage.getItem("Academic");
          console.log("idddddd", academicId);
          // Filter the data based on academic_year_id
          const filteredDetails = details.filter(
            (detail) => detail.academic_year_id === academicId
          );

          setExamDetails(filteredDetails);

          // Extract unique categories from the filtered list
          const uniqueCategories = [
            ...new Set(filteredDetails.map((detail) => detail.category)),
          ];
          setCategories(uniqueCategories);
          setIsDataLoaded(true); // Mark data as loaded
        })
        .catch((error) => console.error("Error fetching exam details:", error));
    }
  }, [selectedClass, selectedDivision, academicId]);

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  // Store selected class in localStorage when it changes
  useEffect(() => {
    if (selectedClass) {
      localStorage.setItem("selectedClass", selectedClass);
    }
    // Reset selected subject when the selected class changes
  }, [selectedClass]);
  useEffect(() => {
    if (selectedDivision) {
      localStorage.setItem("selectedDivision", selectedDivision);
    }
    // Reset selected subject when the selected class changes
  }, [selectedDivision]);

  // Group data by student with subjects as columns, only for exams where is_class_test === "0"
  const getStudentDataByCategory = (category) => {
    const categoryData = examDetails.filter(
      (exam) => exam.category === category && exam.is_class_test === "0"
    );

    // Extract unique students and subjects
    const students = [...new Set(categoryData.map((item) => item.studentname))];
    const subjects = [...new Set(categoryData.map((item) => item.subject))];

    // Organize data by student, subject, and include user_id
    const studentData = students.map((student) => {
      const marksBySubject = {};
      const userIds = new Set(); // To collect unique user_ids for each student
      const examIds = new Set(); // To collect unique exam_ids
      const ids = new Set(); // To collect unique ids for each student entry

      categoryData
        .filter((item) => item.studentname === student)
        .forEach((item) => {
          marksBySubject[item.subject] = item.marks;
          userIds.add(item.user_id); // Collect user_id
          examIds.add(item.exam_id); // Collect exam_id
          ids.add(item.id); // Collect id
        });

      const studentEntry = {
        studentname: student,
        marksBySubject,
        user_ids: Array.from(userIds), // Convert Set to Array to return unique user_ids
        exam_ids: Array.from(examIds), // Convert Set to Array to return unique exam_ids
        ids: Array.from(ids), // Convert Set to Array to return unique ids
      };

      return studentEntry;
    });

    return { studentData, subjects };
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/exam/compliment.php`)
      .then((response) => setCompliments(response.data.data || []))
      .catch((error) => console.error("Error fetching compliments:", error));

    axios
      .get(`${BASE_URL}/admin/exam/list_all_grade_master.php`)
      .then((response) => setGrades(response.data.data || []))
      .catch((error) => console.error("Error fetching grades:", error));
  }, []);
  useEffect(() => {
    const total = parseFloat(internalMark || 0) + parseFloat(writtenMark || 0);
    setTotalMarks(total);
  }, [internalMark, writtenMark]);

  // Form submission handler
  const handleSubmit = () => {
    const formData = {
      class_id: selectedClass,
      division_id: selectedDivision,
      student_id: selectedStudent,
      exam_id: selectedExam,
      marks: totalMarks,
      grade_master_id: selectedGrade,
      compliment_master_id: selectedCompliment,
      description,
      date_of_exam: examDate,
      internal_mark: internalMark,
      written_mark: writtenMark,
      pass: sessionStorage.getItem("user_id"),
      school_id: sessionStorage.getItem("school_id"),

      academic_year_id: academicId,
    };
    console.log("====================================");
    console.log(formData);
    console.log("====================================");

    axios
      .post(
        `${BASE_URL}/admin/exam/create_exam_details.php`,
        formData
      )
      .then((response) => {
        console.log("Form submitted successfully:", response.data);
        onClose();
      })
      .catch((error) => console.error("Error submitting form:", error));
  };

  const handleTdClick = (studentId, id, subject, exam) => {
    console.log("Exam ID:", id);
    setSelectedExamId(id);
    setExam(exam);

    const fetchExamData = () => {
      const url = `${BASE_URL}/staff/exam/view_exam_result.php?id=${id}`;

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("Exam Data:", data.data);

            // Extract the relevant data from the response
            const examData = data.data[0]; // Assuming the result is in the first index

            // Set the state for the modal
            setSelectedSubject(subject);
            setInternalMark(examData.internal_mark); // Set internal mark
            setExternalMark(examData.written_mark); // Set external mark
            setTotalMark(examData.marks); // Set total marks

            // Open the modal
            setIsModalOpen(true);
          } else {
            console.log("Error:", data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching exam data:", error);
        });
    };

    // Fetch exam data immediately
    fetchExamData();

    // Schedule a refresh after 1 second
    setTimeout(() => {
      fetchExamData();
    }, 1000);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = () => {
    const data = {
      id: selectedExamId, // The ID of the exam you're deleting
    };
    console.log("Data sent to delete:", data);

    fetch(`${BASE_URL}/staff/exam/delete_exam_result.php`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert("Exam result deleted successfully");

          // Update the students or exam data by removing the deleted exam result from the state
          setStudents((prevStudents) =>
            prevStudents.map((student) => {
              // Check if 'exam_ids' exists and contains 'selectedExamId'
              if (
                student.exam_ids &&
                student.exam_ids.includes(selectedExamId)
              ) {
                // Filter out the exam result with the selectedExamId
                return {
                  ...student,
                  marksBySubject: Object.fromEntries(
                    Object.entries(student.marksBySubject).filter(
                      ([subject, mark]) => subject !== selectedSubject
                    )
                  ),
                  ids: student.ids.filter((id) => id !== selectedExamId),
                };
              }
              return student;
            })
          );

          // Close the modal
          handleCloseModal();
        } else {
          alert("Failed to delete exam result: " + data.message);
        }
      })
      .catch((error) => {
        console.error("Error deleting exam result:", error);
      });
  };

  const handleSave = async () => {
    if (!internalMark || !externalMark) {
      setError("Both Internal and External marks are required.");
      return;
    }

    const total = parseInt(internalMark) + parseInt(externalMark);
    setTotalMark(total);

    const data = {
      id: selectedExamId, // The ID for the specific exam result to be updated
      exam_id: exam,
      written_mark: externalMark,
      internal_mark: internalMark,
      marks: total,
      description: "", // Add description if needed
      compliment_master_id: "1",
      grade_master_id: "1",
    };

    console.log(data);

    try {
      const response = await fetch(
        `${BASE_URL}/staff/exam/edit_exam_result.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Exam result updated successfully!");
        handleCloseModal(); // Close modal after successful update
      } else {
        alert("Failed to update exam result");
      }
    } catch (error) {
      console.error("Error updating exam result:", error);
      alert("An error occurred while updating the exam result");
    }
  };

  return (
    <>
      <style>
        {`
            .ch {
                text-align: center !important;
            }
                .c{
                text-align: start;}
        `}
      </style>
      <Box borderRadius="md" mx="auto">
        <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
          <div className="teacher-list-container">
            <div className="header">
              <h1 style={{ fontSize: "20px", margin: 0 }}>Exam Results</h1>
              <div className="action-buttons">
                <Flex align="center">
                  <Flex align="center" gap={2}>
                    <FormControl id="class">
                      <Select
                        placeholder="Select class"
                        value={selectedClass}
                        onChange={(e) => setSelectedClass(e.target.value)}
                      >
                        {classes.map((cls) => (
                          <option key={cls.id} value={cls.id}>
                            {cls.class}
                          </option>
                        ))}
                      </Select>
                    </FormControl>

                    {selectedClass && (
                      <FormControl id="division">
                        <Select
                          placeholder="Select division"
                          value={selectedDivision}
                          onChange={(e) => setSelectedDivision(e.target.value)}
                        >
                          {divisions.map((division) => (
                            <option key={division.id} value={division.id}>
                              {division.division}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    <Button
                      className="export-button"
                      display={{ base: "none", md: "flex" }}
                      backgroundColor="white"
                      fontSize="11px"
                      boxShadow="md"
                      onClick={handlePrint} // Attach the print handler here
                    >
                      <FaPrint color="#515B73" />
                      Print PDF
                    </Button>

                    <div style={{ display: "none" }}>
                      <Print_pdf_Exam_result
                        ref={printComponentRef}
                        categories={categories}
                      />
                    </div>
                  </Flex>
                  <Button
                    marginLeft={3}
                    colorScheme="teal"
                    variant="solid"
                    leftIcon={<FaPlus />}
                    onClick={onOpen}
                    mr={2}
                    width={{ base: "0", md: "150px" }} // 100% width on mobile, fixed width on larger screens
                  >
                    <Box display={{ base: "none", md: "block" }}>
                      Add Result
                    </Box>
                  </Button>
                </Flex>
              </div>
            </div>

            <div className="breadcrumb">
              <Link
                to="/admin"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span>Dashboard</span>
              </Link>{" "}
              / <span>Exam</span> / <span>Exam Results</span>
            </div>
          </div>

          <VStack p={6} spacing={4} align="stretch">
            {/* Render Tabs when both class and division are selected */}
            {selectedClass && selectedDivision && categories.length > 0 && (
              <Tabs
                mt={4}
                variant="soft-rounded"
                colorScheme="teal"
                isFitted
                p={2}
                borderRadius="md"
                bg={bgColor}
              >
                <TabList>
                  {categories.map((category) => (
                    <Tab
                      key={category}
                      _selected={{
                        bg: selectedTabBg,
                        color: selectedTabColor,
                        fontWeight: "bold",
                        borderRadius: "md",
                      }}
                      py={2}
                    >
                      {category}
                    </Tab>
                  ))}
                </TabList>

                <TabPanels>
                  {categories.map((category) => {
                    const { studentData, subjects } =
                      getStudentDataByCategory(category);
                    return (
                      <TabPanel key={category} p={4}>
                        <Box overflowX="auto">
                          {" "}
                          {/* Add this Box for horizontal scrolling */}
                          <Table
                            sx={{
                              "tbody tr:nth-of-type(even)": {
                                backgroundColor: "#f2f4f8",
                              },
                            }}
                          >
                            <Thead>
                              <Tr>
                                <Th>Student Name</Th>
                                {subjects.map((subject) => (
                                  <Th key={subject}>{subject}</Th>
                                ))}
                              </Tr>
                            </Thead>
                            <Tbody>
                              {studentData.length > 0 ? (
                                studentData.map((student) => (
                                  <Tr key={student.studentname}>
                                    <Link
                                      to={`/students/detail/${student.user_ids}`}
                                    >
                                      <Td>{student.studentname}</Td>
                                    </Link>
                                    {subjects.map((subject) => {
                                      const subjectIndex = Object.keys(
                                        student.marksBySubject
                                      ).indexOf(subject);

                                      return (
                                        <Td
                                          key={subject}
                                          onClick={() => {
                                            if (subjectIndex !== -1) {
                                              handleTdClick(
                                                student.student_id,
                                                student.ids[subjectIndex], // Pass the correct ID for the subject
                                                subject,
                                                student.exam_ids[subjectIndex] // Pass the correct exam ID for the subject
                                              );
                                            } else {
                                              console.log(
                                                `No data available for subject: ${subject}`
                                              );
                                            }
                                          }}
                                        >
                                          {student.marksBySubject[subject] ||
                                            "-"}
                                        </Td>
                                      );
                                    })}
                                  </Tr>
                                ))
                              ) : (
                                <Tr>
                                  <Td
                                    colSpan={subjects.length + 1}
                                    textAlign="center"
                                  >
                                    No results available
                                  </Td>
                                </Tr>
                              )}
                            </Tbody>
                          </Table>
                        </Box>
                      </TabPanel>
                    );
                  })}
                </TabPanels>
              </Tabs>
            )}
          </VStack>
        </div>

        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size="lg"
          motionPreset="slideInBottom"
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
          <ModalContent
            borderRadius="lg"
            boxShadow="xl"
            bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
            color="gray.700"
            p={6}
            maxW="700px"
            maxH="550px"
            overflowY="auto"
          >
            <ModalHeader
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              color="teal.600"
            >
              <Icon as={FaPlus} boxSize={5} mr={2} />
              Add Marks for Exam Results
            </ModalHeader>{" "}
            <ModalCloseButton />
            <ModalBody
              overflowY="auto"
              px={4}
              css={{
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(173, 216, 230, 0.6)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(173, 216, 230, 0.9)",
                },
              }}
            >
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormControl id="class" mb={4}>
                  <FormLabel>
                    <Icon as={FaChalkboardTeacher} mr={1} color="teal.500" />
                    Class
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select class"
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                  >
                    {classes.length > 0 ? (
                      classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class}
                        </option>
                      ))
                    ) : (
                      <option value="">No classes available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="division" mb={4}>
                  <FormLabel>
                    <Icon as={FaRegFileAlt} mr={1} color="teal.500" />
                    Division
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select division"
                    value={selectedDivision}
                    onChange={(e) => setSelectedDivision(e.target.value)}
                  >
                    {divisions.length > 0 ? (
                      divisions.map((division) => (
                        <option key={division.id} value={division.id}>
                          {division.division}
                        </option>
                      ))
                    ) : (
                      <option value="">No divisions available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="student" mb={4}>
                  <FormLabel>
                    <Icon as={FaUserTie} mr={1} color="teal.500" />
                    Student
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select student"
                    value={selectedStudent}
                    onChange={(e) => setSelectedStudent(e.target.value)}
                  >
                    {students.length > 0 ? (
                      students.map((student) => (
                        <option key={student.id} value={student.id}>
                          {student.name}
                        </option>
                      ))
                    ) : (
                      <option value="">No students available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="exam" mb={4}>
                  <FormLabel>
                    <Icon as={FaClipboardList} mr={1} color="teal.500" />
                    Exam
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select exam"
                    value={selectedExam}
                    onChange={(e) => setSelectedExam(e.target.value)}
                  >
                    {exams.length > 0 ? (
                      exams.map((exam) => (
                        <option key={exam.id} value={exam.id}>
                          {exam.subject} - {exam.category}
                        </option>
                      ))
                    ) : (
                      <option value="">No exams available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="internalMark" mb={4}>
                  <FormLabel>
                    <Icon as={FaPen} mr={1} color="teal.500" />
                    Internal Mark
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={internalMark}
                    onChange={(e) => setInternalMark(e.target.value)}
                  />
                </FormControl>
                <FormControl id="writtenMark" mb={4}>
                  <FormLabel>
                    <Icon as={FaPen} mr={1} color="teal.500" />
                    Written Mark
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={writtenMark}
                    onChange={(e) => setWrittenMark(e.target.value)}
                  />
                </FormControl>
                <FormControl id="totalMarks" mb={4}>
                  <FormLabel>
                    <Icon as={FaTasks} mr={1} color="teal.500" />
                    Total Marks
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={totalMarks}
                    isReadOnly
                  />
                </FormControl>
                <FormControl id="grade" mb={4}>
                  <FormLabel>
                    <Icon as={FaAward} mr={1} color="teal.500" />
                    Grade
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select grade"
                    value={selectedGrade}
                    onChange={(e) => setSelectedGrade(e.target.value)}
                  >
                    {grades.length > 0 ? (
                      grades.map((grade) => (
                        <option key={grade.id} value={grade.id}>
                          {grade.grade}
                        </option>
                      ))
                    ) : (
                      <option value="">No grades available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="compliment" mb={4}>
                  <FormLabel>
                    <Icon as={FaAward} mr={1} color="teal.500" />
                    Compliment
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select compliment"
                    value={selectedCompliment}
                    onChange={(e) => setSelectedCompliment(e.target.value)}
                  >
                    {compliments.length > 0 ? (
                      compliments.map((compliment) => (
                        <option key={compliment.id} value={compliment.id}>
                          {compliment.compliment}
                        </option>
                      ))
                    ) : (
                      <option value="">No compliments available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="description" mb={4}>
                  <FormLabel>
                    <Icon as={FaFileAlt} mr={1} color="teal.500" />
                    Description
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>
                <FormControl id="examDate" mb={4}>
                  <FormLabel>
                    <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                    Exam Date
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="date"
                    value={examDate}
                    onChange={(e) => setExamDate(e.target.value)}
                  />
                </FormControl>
              </SimpleGrid>
            </ModalBody>
            <ModalFooter>
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                mr={3}
                onClick={handleSubmit}
              >
                Submit
              </Button>
              {/* <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button> */}
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          size="lg"
          motionPreset="slideInBottom"
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
          <ModalContent
            borderRadius="lg"
            boxShadow="xl"
            bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
            color="gray.700"
            p={6}
            maxW="700px"
            maxH="550px"
            overflowY="auto"
          >
            <ModalHeader
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              color="teal.600"
            >
              <Icon as={FaEdit} boxSize={5} mr={2} />
              Edit Marks for {selectedSubject}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
              overflowY="auto"
              px={4}
              css={{
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(173, 216, 230, 0.6)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(173, 216, 230, 0.9)",
                },
              }}
            >
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormControl mb={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaPen} mr={1} color="teal.500" />
                    Internal Marks
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={internalMark}
                    onChange={(e) => setInternalMark(e.target.value)}
                  />
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaPen} mr={1} color="teal.500" />
                    External Marks
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={externalMark}
                    onChange={(e) => setExternalMark(e.target.value)}
                  />
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaTasks} mr={1} color="teal.500" />
                    Total Marks
                  </FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    type="number"
                    value={totalMark}
                    isReadOnly
                  />
                </FormControl>
                <FormControl id="grade" mb={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaAward} mr={1} color="teal.500" />
                    Grade
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select grade"
                    value={selectedGrade}
                    onChange={(e) => setSelectedGrade(e.target.value)}
                  >
                    {grades.length > 0 ? (
                      grades.map((grade) => (
                        <option key={grade.id} value={grade.id}>
                          {grade.grade}
                        </option>
                      ))
                    ) : (
                      <option value="">No grades available</option>
                    )}
                  </Select>
                </FormControl>
                <FormControl id="compliment" mb={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaAward} mr={1} color="teal.500" />
                    Compliment
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select compliment"
                    value={selectedCompliment}
                    onChange={(e) => setSelectedCompliment(e.target.value)}
                  >
                    {compliments.length > 0 ? (
                      compliments.map((compliment) => (
                        <option key={compliment.id} value={compliment.id}>
                          {compliment.compliment}
                        </option>
                      ))
                    ) : (
                      <option value="">No compliments available</option>
                    )}
                  </Select>
                </FormControl>
              </SimpleGrid>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="red" onClick={handleDelete}>
                Delete
              </Button>
              <Button colorScheme="blue" ml={1} mr={3} onClick={handleSave}>
                Save
              </Button>
              {/* <Button variant="ghost" onClick={handleCloseModal}>
                Cancel
              </Button> */}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default Exam_Result;
